import axios from "@/plugins/axios";
import utils from "@/stores/utils";
import invitations from "./submodules/invitations";

const state = {
    search: null,
    searching: false,
    searching_errors: false,
    results: [],
    entity: null,
    provider: null,
    usemail: false,
    email: null,
    name: null,
    provider_inviting: false,
};

const mutations = {
    updateSearch(state, search) {
        state.search = search;
    },
    updateSearching(state, saving) {
        state.searching = saving;
    },
    updateSearchingErrors(state, errors) {
        state.searching = false;
        state.searching_errors = errors;
    },
    updateResults(state, results) {
        state.results = results;
    },
    updateProvider(state, provider) {
        state.provider = provider;
    },
    updateEntity(state, entity) {
        state.entity = entity;
        if (entity) {
            state.name = entity.name;
        }
    },
    updateUsemail(state, usemail) {
        state.usemail = usemail;
    },
    updateEmail(state, email) {
        state.email = email;
    },
    updateName(state, name) {
        state.name = name;
    },
    updateProviderInviting(state, inviting) {
        state.provider_inviting = inviting;
    },
};

const actions = {

    async searchProvider({ commit, dispatch, state }, params) {
        if (!state.search) {
            commit("updateResults", []);
            return;
        }
        commit("updateSearching", true);

        try {
            let response = await axios.get("/api/searchentities/", { params: { search: state.search } })
            commit("updateResults", response.data);
            commit("updateSearching", false);
            return response;
        } catch (xhr_error) {
            let errors = utils.handleError(xhr_error);
            commit("updateSearchingErrors", errors.details);
            throw errors
        }
    },


    async inviteProvider({ commit, dispatch, state }, params) {
        try {
            commit("updateProviderInviting", true);
            if (state.provider?.id) {
                const response = await axios.patch(`/api/providers/${state.provider.id}/`, {
                    email_or_safetee_id: state.entity?.safetee_id || state.email,
                });
                return response.data;
            }
            const response = await axios.post("/api/providers/", {
                name: state.provider?.name || state.name,
                email_or_safetee_id: state.entity?.safetee_id || state.email,
            });
            return response.data;
        } catch (xhr_error) {
            let errors = utils.handleError(xhr_error);
            throw errors
        } finally {
            commit("updateProviderInviting", false);
        }
    },

    init({ commit, dispatch, state }, params) {
        commit("updateSearch", params?.provider?.name);
        commit("updateEmail", params?.provider?.address?.email);
        commit("updateName", null);
        commit("updateUsemail", false);
        commit("updateEntity", null);
        commit("updateProvider", params.provider);
        commit("updateResults", []);
        dispatch('searchProvider');
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        invitations: invitations(),
    }
};
